<template>
    <modal name="rebranding-popup" height="auto" width="90%" :max-width="600" :adaptive="true" :scrollable="true">
        <div class="rebranding-modal">
            <div class="icon-cancel rebranding-modal__close-button" @click="closeModal"></div>
            <div class="rebranding-modal__image-box">
                <img
                    :src="require('@/assets/images/featuremodals/rebranding.png')"
                    alt="" class="rebranding-modal__image"
                />
            </div>
            <div class="rebranding-modal__headline">
                <span v-html="$t('RebrandingModal.title')" class="rebranding-modal__title"></span>
            </div>
            <span class="rebranding-modal__paragraph" v-html="$t('RebrandingModal.paragraph')"></span>
            <div class="rebranding-modal__feature-list" v-html="$t('RebrandingModal.list')"></div>

            <TotemButton
                color="primary"
                @click="closeModal"
                class="rebranding-modal__cta-button"
                :label="$t('RebrandingModal.button')"
            />
        </div>
    </modal>
</template>
<script>
export default {
    name: 'modal-rebranding',
    methods: {
        closeModal () {
            this.$modal.hide('rebranding-popup')
        }
    }
}
</script>
<style lang="scss" scoped>
.rebranding-modal {
    background-image: url("~@/assets/images/featuremodals/ellipse.png");
    background-repeat: no-repeat;
    background-position: right -23%;
    border: 0;
    border-radius: 10px 10px 0 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: $tuatara;

    [class*="desktop"] & {
        background-position: right top;
    }

    &__close-button {
        position: absolute;
        right: 20px;
        top: 20px;
        font-size: 2.4rem;
        cursor: pointer;
    }

    &__headline {
        font-family: PPAgrandir-Medium, sans-serif;
        font-size: 1.8rem;
        padding: 60px 20px 0 20px;
        width: 100%;
        flex-direction: column;
        display: flex;

        [class*="desktop"] & {
            padding: 85px 30px 10px 30px;
        }
    }

    &__label {
        font-size: 1.5rem;
        line-height: 110%;
        color: $blaze_orange;

        [class*="desktop"] & {
            font-size: 1.6rem;
        }
    }

    &__title {
        font-size: 1.8rem;
        line-height: 130%;

        [class*="desktop"] & {
            font-size: 2.2rem;
        }
    }

    &__image-box {
        background-color: $medium_blue;
        align-self: center;
        display: flex;
        width: 100%;
        padding: 20px 0 0;

        [class*="desktop"] & {
            padding: 50px 0 0;
        }
    }

    &__image {
        margin: 0 auto;

        [class*="mobile"] & {
            max-height: 140px;
        }
    }

    &__paragraph {
        padding: 14px 30px 4px;
    }

    &__feature-list {
        font-size: 1.6rem;
        line-height: 150%;
        padding: 20px 20px 30px 20px;
        margin: 0 0 0 20px;

        [class*="desktop"] & {
            padding: 20px 30px;
        }

        &::v-deep ul {
            list-style: disc;
            margin: 0;
            padding: 0;
        }

        &::v-deep li {
            list-style-type: disc;
            margin: 0 0 15px 0;

            strong {
                display: block;
            }

            &:last-of-type {
                margin: 0;
            }
        }
    }

    &__item {
        font-family: PlusJakartaSans-Regular, sans-serif;
        font-size: 1.5rem;
        line-height: 150%;

        [class*="desktop"] & {
            font-size: 1.6rem;
        }
    }

    &__cta-button {
        align-self: center;
        margin: 0 0 30px;

        [class*="desktop"] & {
            margin: 10px 0 30px;
        }
    }
}
</style>
<style lang="scss">
[data-modal=rebranding-popup] {
    .v--modal-box.v--modal {
        border-radius: 15px !important;
        padding: 0 !important;
    }
}
</style>
